<template>
  <main class="remove-body-top-padding loginRegister">
        <login-register-desktop v-if="!isMdSize" class="d-xxs-none d-md-flex"/>
        <login-register-mobile v-if="isMdSize" class="d-xxs-flex d-md-none"/>
  </main>
</template>
<script>
  import LoginRegisterDesktop from '@/components/LoginRegisterDesktop.vue'
  import LoginRegisterMobile from '@/components/LoginRegisterMobile.vue'
  import { mapGetters, mapActions } from 'vuex'
  import windowSize from '@/mixins/window-size'
  export default {
    name: 'LoginRegister',
    mixins: [windowSize],
    components: {
      LoginRegisterDesktop,
      LoginRegisterMobile
    },
    data(){
      return{
        isMdSize: false
      }
    },
    methods:{
      handleResize()
      {
        if(window.innerWidth < 1024)
        {
          this.isMdSize = true
        }
        else{
          this.isMdSize = false
        }
      }
    },
    mounted() {
      if(this.isMaxWidth1024())
      {
        this.isMdSize = true
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize)
    },
  }
</script>
